export const GET_CLIENT_FOR_LOBBYIST = "GET_CLIENT_FOR_LOBBYIST"
export const GET_CLIENT = "GET_CLIENT"
export const UPDATE_CLIENT_FOR_LOBBYIST = "UPDATE_CLIENT_FOR_LOBBYIST"
export const ADD_CLIENT_TO_LOBBYIST = "ADD_CLIENT_TO_LOBBYIST"
export const REMOVE_CLIENT_FROM_LOBBYIST = "REMOVE_CLIENT_FROM_LOBBYIST"
export const CLEAR_CLIENT = "CLEAR_CLIENT"
export const CLEAR_CLIENTS_FOR_LOBBYIST = "CLEAR_CLIENTS_FOR_LOBBYIST"


// WEBPACK FOOTER //
// ./src/actionTypes/client.js